import { Reason } from "../types";

export const ENFORCED =
  "Policy enforced to ensure security framework compliance";
export const REPORTING =
  "Policy deployed in reporting mode for baseline assessment";
export const REASSESSMENT =
  "Risk acknowledged with readiness reassessment pending";
export const PERMANENT_SUPPRESSION =
  "Risk acknowledged with permanent policy suppression";

type GenerateReasons = {
  currentBlocker: boolean;
  currentEnabled: boolean;
  inheritedBlocker: boolean;
  inheritedEnabled: boolean;
};

export const generateReasons = ({
  currentBlocker,
  currentEnabled,
  inheritedBlocker,
  inheritedEnabled,
}: GenerateReasons): Reason[] => {
  // https://alt-confluence.rl.lan/display/SwA/Policy+configuration+predetermined+reasons
  const fromPassToFail = currentBlocker && !inheritedBlocker;
  const fromFailToPass = !currentBlocker && inheritedBlocker;
  const fromDisabledToEnabled = currentEnabled && !inheritedEnabled;
  const fromEnabledToDisabled = !currentEnabled && inheritedEnabled;

  return [
    {
      value: ENFORCED,
      // Policy can be enforced only if it is enabled and blocking
      isRecommended:
        (fromPassToFail || fromDisabledToEnabled) &&
        currentEnabled &&
        currentBlocker,
    },
    {
      value: REPORTING,
      // Policy can be in reporting mode only if it is enabled and not blocking
      isRecommended:
        (fromFailToPass || (fromDisabledToEnabled && !currentBlocker)) &&
        currentEnabled,
    },
    {
      value: REASSESSMENT,
      // Reassessment can follow only if policy was enabled previously
      isRecommended:
        (fromFailToPass || fromEnabledToDisabled) && inheritedEnabled,
    },
    {
      value: PERMANENT_SUPPRESSION,
      isRecommended: fromEnabledToDisabled,
    },
  ];
};
